<template>
  <Schema :text="getSchema" />
</template>

<script>
import Schema from './json-schema.vue';

export default {
    name: 'DataFeedItemSchema',
    components: { Schema },
    computed: {
        getSchema() {
          const schema = {
            "@context":"http://schema.org",
            "@type":"DataFeedItem",
            "dateModified": (new Date()).toLocaleDateString('en-CA') // YYYY-MM-DD
          };
          return JSON.stringify(schema);
        },
    },
};
</script>